import React from 'react';
import { useTranslation } from 'react-i18next';
import { MAP_RATING_COLORS } from '../../../constants/colors';
import './RecentRatingChanges.css';

export interface RatingChange {
  id: string;
  name: string;
  shortName: string;
  date: string;
  oldRating: string;
  newRating: string;
  direction: 'upgraded' | 'downgraded';
}

interface RecentRatingChangesProps {
  changes: RatingChange[];
  onInstitutionClick: (inst: { id: string; name: string }) => void;
  comparisonLabel: string;
}

const RecentRatingChanges: React.FC<RecentRatingChangesProps> = ({
  changes,
  onInstitutionClick,
  comparisonLabel,
}) => {
  const { t } = useTranslation();

  if (changes.length === 0) return null;

  return (
    <div className="recent-changes-section">
      <h3 className="section-title">{t('map.recentRatingChanges')}</h3>
      <ul className="changes-list">
        {changes.map((change) => (
          <li
            key={change.id}
            className="change-item"
            onClick={() => onInstitutionClick({ id: change.id, name: change.name })}
          >
            <span className={`change-icon change-icon--${change.direction}`}>
              {change.direction === 'upgraded' ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M7 17l5-5 5 5" />
                  <path d="M7 12l5-5 5 5" />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M7 7l5 5 5-5" />
                  <path d="M7 12l5 5 5-5" />
                </svg>
              )}
            </span>
            <div className="change-info">
              <span className="change-name">{change.shortName}</span>
              <span className="change-date">{comparisonLabel}</span>
            </div>
            <div className="change-ratings">
              <span
                className="change-rating-old"
                style={{ color: MAP_RATING_COLORS[change.oldRating] || '#999' }}
              >
                {change.oldRating}
              </span>
              <span className="change-arrow">→</span>
              <span
                className="change-rating-new"
                style={{ color: MAP_RATING_COLORS[change.newRating] || '#999' }}
              >
                {change.newRating}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentRatingChanges;
